<template>
    <div class="animated fadeIn">
      <transition name="fade">
        <loading v-show="isLoading"></loading>
      </transition>
        <b-modal @close="hideModal" @hide="hideModal" ref="modal-addAsign" scrollable centered>
            <template #modal-title>
              <i class="fas fa-user"></i> {{ title }}
            </template>
            <h4 class="warn__tittle">ATENÇÃO</h4>
            <p class="warn__subtitle">{{warnMessage}}</p>
            <hr>
            <div class="form-group row">
                <div class="col-md-12">
                  <label><small class="text-danger">*</small> Selecione o tipo que dejesa {{modalType === 'add' ? 'atribuir' : 'remover'}}:</label>
                  <div>
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                      @change="manageRadioButton"
                      v-model="selected"
                      :aria-describedby="ariaDescribedby"
                      :required="true"
                      >
                        <b-form-radio value="person">Pessoa</b-form-radio>
                        <b-form-radio value="group">Grupo</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                  <template v-if="modalType === 'add'">
                  <div v-if="selected === 'person'" class="form-group row pt-2">
                    <div class="col-md-12">
                      <label for="txtGroup"><small class="text-danger">*</small> Pessoa Responsável:</label>
                      <div class="input-group">
                        <span class="input-group-addon"><i class="fas fa-user"></i></span>
                        <b-form-select v-model="form.responsiblePerson.value" :required="form.responsiblePerson.required" :options="form.responsiblePerson.options">
                          <template slot="first">
                            <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                          </template>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                  <div v-if="selected === 'group'" class="form-group row pt-2">
                    <div class="col-md-12">
                      <label for="txtGroup"><small class="text-danger">*</small> Grupo Responsável:</label>
                      <div class="input-group">
                        <span class="input-group-addon"><i class="fas fa-users"></i></span>
                        <b-form-select v-model="form.responsibleGroup.value" :required="form.responsibleGroup.required" :options="form.responsibleGroup.options">
                          <template slot="first">
                            <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                          </template>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                </template>
                </div>
              </div>
              <template #modal-footer>
                <div class="w-100 text-right">
                  <button v-if="eventManager" type="button" class="btn btn-third btn-sm rounded" @click.prevent="onSave" v-b-tooltip.hover :title="eventManager.hasNext ? 'Próximo' : 'Salvar'">
                    <i :class="eventManager.hasNext ? 'far fa-arrow-alt-circle-right' : 'fas fa-check-circle'"></i><span class="d-md-down-none"> {{eventManager.hasNext ? 'Próximo' : 'Salvar'}}</span>
                  </button>
                  <button v-else type="button" class="btn btn-third btn-sm rounded" @click.prevent="onSave" v-b-tooltip.hover :title="'Salvar'">
                    <i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span>
                  </button>
                </div>
              </template>

        </b-modal>
    </div>
</template>

<script>
import AddAsignModal from './addAsign.js'
export default AddAsignModal
</script>
<style lang="scss">
.warn{
    &__tittle{
        color: #F00;
        font-size: 1rem;
        font-weight: 600;
    }
    &__subtitle{
        color: #505050;
        font-size: .75rem;
        font-weight: 400;
    }
    hr{
        margin: 1.25rem 1rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/private/cobranca/modal/asign/addAsign.vue